import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function RequireAuth({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return <div className="h-screen flex items-center justify-center"><Loader2 className="animate-spin text-blue-600" size={32} /></div>;
  }
  if (user === false) return <Navigate to="/espace-courtier" replace />;
  return children;
}
